import {Component, Input} from '@angular/core';

@Component({
    selector: 'form-field',
    template: `
        <div class="form-group">
            <label *ngIf="label">
                {{label}}
            </label>
            <ng-content></ng-content>
            <div class="form-errors" *ngIf="!field.valid">
                <div *ngIf="field.hasError('required')"></div>
                <div *ngIf="field.hasError('mask')">Data format is not valid</div>
                <div *ngIf="field.hasError('minlength')">Must be at least {{minlength}} characters long</div>
                <div *ngIf="field.hasError('maxlength')">Must be not more than {{maxlength}} characters long</div>
                <div *ngIf="field.hasError('email')">Please enter a valid email address.</div>
                <div *ngIf="field.hasError('remote')">{{field.errors.remote}}</div>
                <div *ngIf="field.hasError('confirm')">Your passwords do not match</div>
                <div *ngIf="field.hasError('min')">Must be greater then {{min}}</div>
                <div *ngIf="field.hasError('max')">Must be less then {{max}}</div>
            </div>
        </div>
    `
})

export class FormFieldComponent {
    @Input() field: any;
    @Input() name: string;
    @Input() label: string;
    @Input() title: string;
    @Input() min: string;
    @Input() max: string;
    @Input() maxlength: string;
    @Input() minlength: string;

}